// extracted by mini-css-extract-plugin
module.exports = {"message":"CookiesWarning_message__VMju0","button":"CookiesWarning_button__s0tRo"};